/** basic.deviceImport */
export default {
    import_plarform: "Платформа",
    import_plarformPla: "Выберите платформу для поиска",
    import_type: "Тип импорта",
    import_import: "Импорт",
    import_signOut: "Деактивация",
    import_importEntity: "Организация импорта",
    import_singIngPlafrom: "Платформа регистрации",
    import_importPlatform: "Платформа импорта",
    import_Time: "Время импорта",
    import_Log: "Журнал импорта",
    import_state: "Статус импорта",
    import_download: "Скачать вложение",
    import_dialogTitle: "Импорт устройств",
    import_singIngPlafromPla: "Выберите платформу регистрации",
    import_expireTime: "Срок действия",
    import_selectTime: "Выберите дату",
    import_drawerTitle: "Детали импорта устройств",
    import_deviceState: "Статус импорта устройств",
    import_signInResult: "Результат регистрации",
    import_successful: "Успешно",
    import_lose: "Неудачно",
    import_NosignInLog: "Журнал регистрации",

    import_signInLog: "Журнал регистрации",
    import_signInTime: "Время регистрации",
    import_allType: "Все типы импорта",
    import_deviceImport: "Импорт устройств",
    import_deviceSignOut: "Деактивация устройств",
    import_importSucc: "Импорт выполнен!",
    import_importLose: "Импорт не выполнен!",

    message_devcieModelNum: "Модель устройства не может быть пустой!",
    message_signInPlarform: "Платформа регистрации не может быть пустой!",
    message_importEntity: "Организация импорта не может быть пустой!",
    message_devcieType: "Тип устройства не может быть пустым!",
    message_importNo: "Файл импорта не может быть пустым!",
    import_file_type: "Можно загружать только файлы .xlsx",
}

